import React, { useContext, useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { configureNuance, loadNuanceScript } from "../../utils/Nuance";

const NuanceContext = React.createContext();

export function useNuanceContext() {
  return useContext(NuanceContext);
};

export default function NuanceWrapper({ children }) {

  const [nuanceState, setNuanceState] = useState('ACTIVE');
  
  const { user } = useSelector(
    ({ auth }) => ({
      user: auth?.user,
    }),
    shallowEqual
  );
  
  const initializeNuanceInstance = () => {
    if (typeof window?.NUSA_initializeVuiForm !='undefined' && !window?.NUSA_initializeVuiForm()) {
      const promise = Promise.resolve(window?.NUSA_reinitializeVuiForm());
      promise.then(() => {
        setNuanceState('ACTIVE');
      });
    }
  }

  const isNuanceEnabled = () => {
    // Return boolean `true` if Nuance is already enabled, otherwise `false`
    return (
      document.getElementById('NUSAI_CommandBar_Container') &&
      document.getElementById('NUSAI_CommandBar_Container').style.visibility == "visible"
    );
  }

  const isNuanceRecording = () => {
    return (document.getElementById('NUSAI_CommandBar_Container') && 
            document.getElementById('NUSAI_CommandBar_Container').querySelectorAll('.NUSAI_CommandBar_Record_On').length > 0);
  }

  const startNuanceRecording = (inputID) => {
    if (isNuanceEnabled()) {
      if (!isNuanceRecording()) {
        window?.NUSA_startRecording();
        setNuanceState('RECORDING');
      }
      if (inputID) {
        if (document?.getElementById(inputID)?.className?.indexOf('ui-select-style') > -1) {
          document?.getElementById(inputID)?.querySelector('input[aria-autocomplete="list"]')?.focus();
        } else {
          document?.getElementById(inputID)?.focus();
        }
      }
    }
  }

  const initializeNuance = () => {
    setNuanceState('ACTIVE');
    initializeNuanceInstance();
  }

  const reinitializeNuance = () => {
    setTimeout(() => {
      if (window?.document.querySelectorAll("textarea[data-nusa-enabled]:not([data-nusa-id])").length > 0) {
        if (window?.NUSA_reinitializeVuiForm) {
          window?.NUSA_reinitializeVuiForm();
        }
      }
    }, 1000);
  }

  const stopNuanceRecording = () => {
    setNuanceState('ACTIVE');
    window?.NUSA_stopRecording && window?.NUSA_stopRecording();
  }

  const closeNuance = () => {
    setNuanceState('INACTIVE');
    window?.NUSA_closeVuiForm && window?.NUSA_closeVuiForm();
  }

  const defaultValues = {
    nuanceState,
    setNuanceState,
    initializeNuance,
    startNuanceRecording,
    stopNuanceRecording,
    isNuanceRecording,
    reinitializeNuance,
    isNuanceEnabled,
    closeNuance,
  };

  useEffect(() => {
    if (user) {
      loadNuanceScript(user, setNuanceState, isNuanceEnabled);
    }
  }, [user]);

  return (
    <NuanceContext.Provider value={defaultValues}>
      {children}
    </NuanceContext.Provider>
  );
};
